export default "__VITE_ASSET__B09cy7WS__"